const burger = document.getElementById('burger');
const menu = document.getElementById('menu');

if(burger && menu) {
    burger.addEventListener('click', () => {
        if(burger.classList.contains('open')) {
            burger.classList.remove('open');
            menu.classList.remove('open');
            document.querySelector("body").style.overflow = "auto";
        } else {
            burger.classList.add('open');
            menu.classList.add('open');
            document.querySelector("body").style.overflow = "hidden";
        }
    });
}

let expandButtons = document.querySelectorAll(".header__menu-expand");
if(expandButtons) {
    for(let i = 0; i < expandButtons.length; i++) {
        expandButtons[i].addEventListener("click", (event) => {
            event.preventDefault();
            if(expandButtons[i].classList.contains("expanded")) {
                expandButtons[i].classList.remove("expanded");
                expandButtons[i].parentNode.querySelector(".header__menu-sub").classList.remove("expanded"); 
            } else {
                for(let z = 0; z < expandButtons.length; z++) {
                    expandButtons[z].classList.remove("expanded");
                    expandButtons[z].parentNode.querySelector(".header__menu-sub").classList.remove("expanded");
                }
                expandButtons[i].classList.add("expanded");
                expandButtons[i].parentNode.querySelector(".header__menu-sub").classList.add("expanded");
            }
        })
    }
}

